import { useToggle } from "@react-hookz/web";
import { type FunctionComponent, useEffect } from "react";

import { useSearchContext } from "~/components/search/contexts";
import { paywall } from "~/data";

import IconCheckboxChecked from "./icon-checkbox-checked.svg";
import IconCheckboxCheckedOff from "./icon-checkbox-off.svg";
import { BoldWord, Container, Content } from "./styles";

type Props = {
  className?: string;
};

export const PlusCheckbox: FunctionComponent<Props> = ({ className }) => {
  const { paywallTypeIds, searchPageType, setExcludePaywallTypeIds, setPaywallTypeIds } =
    useSearchContext();
  const [isChecked, setIsChecked] = useToggle(
    paywallTypeIds?.includes(paywall.scmpPlus.entityUuid),
  );

  const renderCheckbox = () => {
    if (isChecked) {
      return <IconCheckboxChecked />;
    }
    return <IconCheckboxCheckedOff />;
  };

  useEffect(() => {
    if (searchPageType !== "plus") return;
    if (isChecked) {
      setExcludePaywallTypeIds?.([]);
      setPaywallTypeIds?.([paywall.scmpPlus.entityUuid]);
    } else {
      setExcludePaywallTypeIds?.([]);
      setPaywallTypeIds?.([]);
    }
  }, [isChecked, searchPageType, setExcludePaywallTypeIds, setPaywallTypeIds]);
  if (searchPageType !== "plus") return null;

  return (
    <Container
      className={className}
      onClick={() => {
        setIsChecked();
      }}
    >
      {renderCheckbox()}
      <Content>
        Only show
        <BoldWord> SCMP Plus </BoldWord>
        articles
      </Content>
    </Container>
  );
};

PlusCheckbox.displayName = "PlusCheckbox";
